var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","rounded":"","vertical":_vm.vertical,"color":_vm.Alert.color},model:{value:(_vm.Alert.status),callback:function ($$v) {_vm.$set(_vm.Alert, "status", $$v)},expression:"Alert.status"}},[_c('span',{staticClass:"text-subtitle-2",domProps:{"textContent":_vm._s(_vm.Alert.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }